import { GameConstants } from "../../GameConstants";
import { GameManager } from "../../GameManager";
import { GameVars } from "../../GameVars";
import { AudioManager } from "../../AudioManager";
import { TutorialLayer } from "../TutorialLayer";

export class SplashState extends Phaser.State {

    public static currentInstance: SplashState;  

    private tutorialLayer: Phaser.Group;
    private audioOnButton: Phaser.Button;
    private audioOffButton: Phaser.Button;
    private tutorialButton: Phaser.Button;
    private easyButton: Phaser.Button;
    private mediumButton: Phaser.Button;
    private hardButton: Phaser.Button;
    private f: number;

    public init(): void {
        
        SplashState.currentInstance = this;

        this.f = 0;
    }
    
    public create(): void {

        const scaledItemsContainer = this.add.group();
        scaledItemsContainer.x = GameConstants.GAME_WIDTH / 2;
        scaledItemsContainer.y = GameConstants.GAME_HEIGHT / 2;
        scaledItemsContainer.scale.y = GameVars.scaleY;
        scaledItemsContainer.alpha = 0;

        const splashIllustration = this.add.image( 0, 200, "splash");
        splashIllustration.anchor.set(.5);
        scaledItemsContainer.add(splashIllustration);

        this.audioOnButton = new Phaser.Button(this.game,  GameConstants.GAME_WIDTH - 50, 50 * GameVars.scaleY, "texture_atlas_1", this.onClickAudioButton, this);
        this.audioOnButton.setFrames( "btn_sound_on", "btn_sound_on", "btn_sound_on", "btn_sound_on");
        this.audioOnButton.anchor.set(.5);
        this.audioOnButton.scale.y = GameVars.scaleY;
        this.add.existing(this.audioOnButton);

        this.audioOffButton = new Phaser.Button(this.game, GameConstants.GAME_WIDTH - 50, 50 * GameVars.scaleY, "texture_atlas_1", this.onClickAudioButton, this);
        this.audioOffButton.setFrames( "btn_sound_off", "btn_sound_off", "btn_sound_off", "btn_sound_off");
        this.audioOffButton.anchor.set(.5);
        this.audioOffButton.scale.y = GameVars.scaleY;
        this.add.existing(this.audioOffButton);

        this.tutorialButton = new Phaser.Button(this.game, 50, 50 * GameVars.scaleY, "texture_atlas_1", this.onClickTutorial, this);
        this.tutorialButton.setFrames( "btn_info", "btn_info", "btn_info", "btn_info");
        this.tutorialButton.anchor.set(.5);
        this.tutorialButton.scale.y = GameVars.scaleY;
        this.add.existing(this.tutorialButton);

        if (GameVars.gameData.muted) {
            this.audioOnButton.visible = false;
            this.audioOffButton.visible = true;
        } else {
            this.audioOnButton.visible = true;
            this.audioOffButton.visible = false;
        }

        const extra = new Phaser.Image(this.game, 200, -325, "texture_atlas_1", "title_minesweeper_extra");
        extra.anchor.set(.5);
        scaledItemsContainer.add(extra);

        const gameTitle = new Phaser.Image(this.game, 0, -305, "texture_atlas_1", "title_minesweeper");
        gameTitle.anchor.set(.5);
        scaledItemsContainer.add(gameTitle);

        const classic = new Phaser.Image(this.game, -135, -395, "texture_atlas_1", "title_minesweeper_classic");
        classic.anchor.set(.5);
        scaledItemsContainer.add(classic);
       
        this.easyButton = new Phaser.Button(this.game, 0, -35, "texture_atlas_1", this.onClickPlay, this);
        this.easyButton.setFrames("btn_easy", "btn_easy", "btn_easy", "btn_easy");
        this.easyButton.anchor.set(.5);
        this.easyButton.name = GameConstants.DIFFICULTY_EASY;
        this.easyButton.visible = false;
        scaledItemsContainer.add(this.easyButton);

        this.mediumButton = new Phaser.Button(this.game, 0, 80, "texture_atlas_1", this.onClickPlay, this);
        this.mediumButton.setFrames("btn_medium", "btn_medium", "btn_medium", "btn_medium");
        this.mediumButton.anchor.set(.5);
        this.mediumButton.name = GameConstants.DIFFICULTY_MEDIUM;
        this.mediumButton.visible = false;
        scaledItemsContainer.add(this.mediumButton);

        this.hardButton = new Phaser.Button(this.game, 0, 200, "texture_atlas_1", this.onClickPlay, this);
        this.hardButton.setFrames("btn_hard", "btn_hard", "btn_hard", "btn_hard");
        this.hardButton.anchor.set(.5);
        this.hardButton.name = GameConstants.DIFFICULTY_HARD;
        this.hardButton.visible = false;
        scaledItemsContainer.add(this.hardButton);

        this.game.add.tween(scaledItemsContainer)
            .to ({alpha: 1}, 450, Phaser.Easing.Cubic.Out, true)
            .onComplete.add(function(): void {
                this.easyButton.visible = true;
                this.mediumButton.visible = true;
                this.hardButton.visible = true;
            }, this);

        
        if (GameConstants.SPONSOR !== GameConstants.SPONSOR_FUNO) {
            AudioManager.playSound("splash_soundtrack_abridged", true);
        }    
       
        this.game.time.events.add(150, this.animateButtons, this);
    }

    public shutdown(): void {
        
        SplashState.currentInstance = null;
        
        super.shutdown();
    }

    public update(): void {

        super.update();

        this.f ++;

        if (this.f === 90) {

            this.f = 0;
            this.animateButtons();
        }
    }

    public closeTutorial(): void {
        this.tutorialLayer.destroy();
        this.tutorialLayer = null;
    }

    private animateButtons(): void {

        this.game.add.tween(this.easyButton.scale)
            .to ({x: 1.065, y: 1.065}, 150, Phaser.Easing.Cubic.Out, true, 0, 0, true);

        this.game.add.tween(this.mediumButton.scale)
            .to ({x: 1.065, y: 1.065}, 150, Phaser.Easing.Cubic.Out, true, 300, 0, true);

        this.game.add.tween(this.hardButton.scale)
            .to ({x: 1.065, y: 1.065}, 150, Phaser.Easing.Cubic.Out, true, 600, 0, true);
    }

    private onClickAudioButton(): void {
        
        AudioManager.toggleAudioState();

        if (GameVars.gameData.muted) {
            this.audioOnButton.visible = false;
            this.audioOffButton.visible = true;
        } else {
            this.audioOnButton.visible = true;
            this.audioOffButton.visible = false;
        }
    }

    private onClickPlay(b: Phaser.Button): void {

        this.camera.fade(0x3d2c2e, 350);
        this.game.camera.onFadeComplete.add(function(): void {
            GameManager.enterBoardScene(b.name);
        }, this);
        
        AudioManager.playSound("btn_click");
    }

    private onClickTutorial(): void {

        this.tutorialLayer = new TutorialLayer(this.game);
        this.add.existing(this.tutorialLayer);
        GameVars.tutorialFromSplash = true;

        AudioManager.playSound("btn_click");
    }
}
